import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/containers/accordion.containers';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';

export default function AdminLevelTwoBasicInfoComponent({
    handleInnerFormChange,
    selectedCategory, ParentAdminLayerId,
}: any) {
    return (
        <>
            <AccordionContainer
                headerTitle="New Admin Level 2"
                expandedPanel="userInfo"
                child={
                    <div className="grid md:grid-cols-2 gap-4">

                        <InputContainer
                            label="Parent Admin Layer"
                            labelField="Name"
                            list={ParentAdminLayerId}
                            type="select"
                            optionName="Select Global Admin Layer 1"
                            isDisabled={!!selectedCategory?.GlobalAdminLayer2Id}
                            value={selectedCategory?.ParentAdminLayerId}
                            valueField="GlobalAdminLayer1Id"
                            onValueChange={(event: any) => {
                                const selectedId = Number(event.target.value);

                                handleInnerFormChange(
                                    selectedId,
                                    "GlobalAdminLayer1Id"
                                );
                            }}
                        />
                        <InputContainer
                            label="Group Code"
                            name="Code"
                            type="text"
                            value={selectedCategory?.Code}
                            isDisabled={!!selectedCategory?.GlobalAdminLayer2Id}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Code'
                                );
                            }}
                        />

                        <InputContainer
                            label="Group Name"
                            name="Name"
                            type="text"
                            value={selectedCategory?.Name}
                            isDisabled={!!selectedCategory?.GlobalAdminLayer2Id}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Name'
                                );
                            }}
                        />
                        <div className="md:col-span-2">
                            <InputContainer
                                label="Label"
                                name="Label"
                                type="text"
                                value={selectedCategory?.Label}
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'Label'
                                    );
                                }}
                            />
                        </div>

                        <div className="md:col-span-2">
                            <InputContainer
                                label="Description"
                                name="Description"
                                type="text"
                                value={selectedCategory?.Description}
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'Description'
                                    );
                                }}
                            />
                        </div>


                    </div>
                }
            />
        </>
    );
}